const n = (e) => {
  const t = [
    "and",
    "do",
    "case",
    "endcase",
    "otherwise",
    "each",
    "else",
    "enddo",
    "endfor",
    "endif",
    "endnew",
    "for",
    "if",
    "in",
    "inout",
    "load",
    "new",
    "none",
    "not",
    "or",
    "like",
    "order",
    "out",
    "parm",
    "refresh",
    "return",
    "to",
    "when",
    "where",
    "using",
    "from",
    "unique",
    "input",
    "while",
    "composite",
    "endcomposite",
    "context",
    "use",
    "on",
    "level"
  ], r = [
    "count",
    "error",
    "link",
    "msg",
    "newline",
    "noaccept",
    "noprompt",
    "serial",
    "sum",
    "today",
    "format",
    "abs",
    "adddays",
    "addmth",
    "addyr",
    "age",
    "asc",
    "average",
    "chr",
    "cols",
    "compare",
    "concat",
    "create",
    "createfromurl",
    "ctod",
    "ctot",
    "day",
    "decrypt64",
    "dow",
    "dtoc",
    "encrypt64",
    "eom",
    "exists",
    "fileexist",
    "find",
    "frombase64",
    "getcookie",
    "getdatastore",
    "getencryptionkey",
    "getlanguage",
    "getlocation",
    "getmessagetext",
    "getsoaperr",
    "getsoaperrmsg",
    "gettheme",
    "gxgetmli",
    "gxmllines",
    "htmlclean",
    "hour",
    "iif",
    "int",
    "isnull",
    "len",
    "lower",
    "ltrim",
    "max",
    "min",
    "minute",
    "mod",
    "month",
    "null",
    "nullvalue",
    "now",
    "opendocument",
    "padl",
    "padr",
    "pathtourl",
    "printdocument",
    "random",
    "readregkey",
    "remoteaddr",
    "returnonclick",
    "rgb",
    "round",
    "roundtoeven",
    "rseed",
    "rtrim",
    "rows",
    "second",
    "serverdate",
    "servernow",
    "servertime",
    "setcookie",
    "setlanguage",
    "settheme",
    "setuserid",
    "setwrkst",
    "shell",
    "sleep",
    "space",
    "str",
    "strreplace",
    "strsearch",
    "strsearchrev",
    "substr",
    "sysdate",
    "systime",
    "tadd",
    "tdiff",
    "tocbase64",
    "toformattedstring",
    "trim",
    "trunc",
    "ttoc",
    "udp",
    "upper",
    "urldecode",
    "urlencode",
    "userid",
    "val",
    "wrkst",
    "xslapply",
    "ymdhmstot",
    "ymdtod",
    "aftercomplete",
    "afterdelete",
    "afterinsert",
    "afterlevel",
    "afterupdate",
    "aftervalidate",
    "beforecomplete",
    "beforedelete",
    "beforeinsert",
    "beforeupdate",
    "beforevalidate"
  ];
  return {
    name: "GeneXus",
    case_insensitive: !0,
    keywords: {
      keyword: t.join(" "),
      literal: "true false null",
      built_in: r.join(" ")
    },
    contains: [
      e.C_LINE_COMMENT_MODE,
      e.COMMENT("/\\*", "\\*/"),
      {
        className: "string",
        begin: '@"',
        end: '"',
        contains: [{ begin: '""' }]
      },
      e.QUOTE_STRING_MODE,
      e.APOS_STRING_MODE,
      e.C_NUMBER_MODE,
      {
        className: "variable",
        begin: "&\\w+\\b"
      },
      {
        className: "meta",
        begin: "\\bsub\\b",
        end: "\\bendsub\\b",
        contains: [
          {
            className: "title",
            begin: "\\bsub\\b\\s+",
            end: "(?=\\s|$)",
            excludeBegin: !0
          }
        ]
      }
    ]
  };
};
export {
  n as default,
  n as genexus
};
